import { ViewModel } from "./viewModel";
import View from "./view";

const Subscription = () => {
  return (
    <ViewModel>
      <View />
    </ViewModel>
  );
};

export default Subscription;
